export default __webpack_public_path__ + "static/media/icon_elight_tube.ea431889.png";